export const ICON_SIZE_IN_PIXEL = 16;
export const TEXT_OF_PI_CONTENT = 'Some models are only sold by parallel importers.'; // @suppress longLineCheck
